import React, { Component } from 'react';
import { connect } from 'react-redux';
import { crudUpdate, SaveButton } from 'react-admin';

// A custom action creator which modifies the values before calling the default crudCreate action creator
const saveWithNote = (values, basePath, redirectTo) => {
    return crudUpdate('password_change', values.id,
        {"password": values.password, "new_password": values.new_password, "new_password_confirm": values.new_password_confirm},
        basePath, redirectTo);
}

class CleanChangePasswordView extends Component {
    handleClick = () => {
        const { basePath, handleSubmit, redirect, saveWithNote } = this.props;

        return handleSubmit(values => {
            saveWithNote(values, basePath, redirect);
        });
    };

    render() {
        const { handleSubmitWithRedirect, saveWithNote, ...props } = this.props;

        return (
            <SaveButton
                handleSubmitWithRedirect={this.handleClick}
                {...props}
            />
        );
    }
}

export const CleanChangePassword = connect(
    undefined,
    { saveWithNote }
)(CleanChangePasswordView);
